// 원격 문열림 실제 결과 (LETMEUP-1200)
// 소켓 서버가 방 가입 응답에 features: ['door_result_v1'] 을 주면, 문열기 요청에 ACK를 붙여
// 대상 키오스크의 실제 결과를 받는다. 구버전 서버에서는 기존처럼 전송만 하고 안내하지 않는다.

export const SERVER_FEATURE_DOOR_RESULT = 'door_result_v1';
// 서버 결과 대기(6초)보다 조금 길게
export const DOOR_RESULT_ACK_TIMEOUT_MS = 8000;

export type DoorOpenStatus =
  | 'opened' // 대상 키오스크가 문을 열고 릴레이 상태로 확인
  | 'opened_unverified' // 대상 키오스크가 문열림 신호 전송, 상태 확인 불가
  | 'failed' // 대상 키오스크가 실패 보고
  | 'unverified' // 결과 없음(구버전 키오스크·오프라인·타임아웃). 열렸을 수도 있음
  | 'rejected'; // 서버가 처리하지 않음(속도 제한 등)

export interface DoorOpenResult {
  status: DoorOpenStatus;
  code: string | null;
}

const KNOWN_STATUSES = new Set<DoorOpenStatus>(['opened', 'opened_unverified', 'failed', 'unverified', 'rejected']);

export const hasDoorResultFeature = (payload: unknown): boolean => {
  const features = (payload as { features?: unknown } | null | undefined)?.features;
  return Array.isArray(features) && features.includes(SERVER_FEATURE_DOOR_RESULT);
};

export const toDoorOpenResult = (response: unknown): DoorOpenResult => {
  const value = (response ?? {}) as { status?: unknown; code?: unknown };
  const status = KNOWN_STATUSES.has(value.status as DoorOpenStatus) ? (value.status as DoorOpenStatus) : 'unverified';
  return { status, code: value.code == null ? null : String(value.code) };
};

// "결과 확인 불가"는 실패가 아니다. 문이 열렸을 수 있으므로 성공·실패로 단정하지 않는다.
export const getDoorOpenMessage = (result: DoorOpenResult): { level: 'success' | 'error' | 'info'; text: string } => {
  switch (result.status) {
    case 'opened':
      return { level: 'success', text: '문이 열렸어요.' };
    case 'opened_unverified':
      return { level: 'success', text: '문열림 신호를 보냈어요. (문 상태는 확인할 수 없어요)' };
    case 'failed':
      return { level: 'error', text: '키오스크에서 문을 열지 못했어요. 키오스크의 문 연결 상태를 확인해 주세요.' };
    case 'rejected':
      return { level: 'error', text: '요청이 너무 많아요. 잠시 뒤 다시 시도해 주세요.' };
    case 'unverified':
    default:
      if (result.code === 'KIOSK_RESULT_UNSUPPORTED') {
        return {
          level: 'info',
          text: '문열기 요청을 보냈어요. 이 키오스크는 열림 결과를 보내주지 않아 실제 문이 열렸는지는 현장에서 확인해 주세요.',
        };
      }
      return {
        level: 'info',
        text: '문열기 요청을 보냈지만 응답을 확인하지 못했어요. 실제 문 열림 여부를 먼저 확인하고, 열리지 않았다면 키오스크 전원과 인터넷 연결을 확인해 주세요.',
      };
  }
};
